// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._2rko1l7b{border-radius:3px}
._2rko1q5u{border-radius:var(--ds-border-radius-circle,50%)}
._2rkob7nn{border-radius:var(--ds-border-radius-300,9pt)}
._2rkogqwt{border-radius:var(--ds-border-radius-050,2px)}
._2rkoi2wt{border-radius:6px}._16jlkb7n{flex-grow:1}
._175216xz svg{height:6pc}
._17521qr7 svg{height:8pc}
._17521tcg svg{height:24px}
._17521ylp svg{height:40px}
._17527vkz svg{height:1pc}
._1752zwfg svg{height:2pc}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1o9zkb7n{flex-shrink:1}
._4t3i1osq{height:100%}
._bfhk1v33{background-color:var(--ds-background-accent-gray-subtler,#dcdfe4)}
._bfhkr4aa{background-color:var(--ds-icon-subtle,#8993a4)}
._i0dl1osq{flex-basis:100%}
._w8l516xz svg{width:6pc}
._w8l51qr7 svg{width:8pc}
._w8l51tcg svg{width:24px}
._w8l51ylp svg{width:40px}
._w8l57vkz svg{width:1pc}
._w8l5zwfg svg{width:2pc}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/avatar/dist/esm/internal/avatar-image.compiled.css"],"names":[],"mappings":";AACA,WAAW,iBAAiB;AAC5B,WAAW,gDAAgD;AAC3D,WAAW,6CAA6C;AACxD,WAAW,6CAA6C;AACxD,WAAW,iBAAiB,CAAC,WAAW,WAAW;AACnD,eAAe,UAAU;AACzB,eAAe,UAAU;AACzB,eAAe,WAAW;AAC1B,eAAe,WAAW;AAC1B,eAAe,UAAU;AACzB,eAAe,UAAU;AACzB,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,aAAa;AACxB,WAAW,WAAW;AACtB,WAAW,iEAAiE;AAC5E,WAAW,8CAA8C;AACzD,WAAW,eAAe;AAC1B,eAAe,SAAS;AACxB,eAAe,SAAS;AACxB,eAAe,UAAU;AACzB,eAAe,UAAU;AACzB,eAAe,SAAS;AACxB,eAAe,SAAS","sourcesContent":["\n._2rko1l7b{border-radius:3px}\n._2rko1q5u{border-radius:var(--ds-border-radius-circle,50%)}\n._2rkob7nn{border-radius:var(--ds-border-radius-300,9pt)}\n._2rkogqwt{border-radius:var(--ds-border-radius-050,2px)}\n._2rkoi2wt{border-radius:6px}._16jlkb7n{flex-grow:1}\n._175216xz svg{height:6pc}\n._17521qr7 svg{height:8pc}\n._17521tcg svg{height:24px}\n._17521ylp svg{height:40px}\n._17527vkz svg{height:1pc}\n._1752zwfg svg{height:2pc}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1o9zkb7n{flex-shrink:1}\n._4t3i1osq{height:100%}\n._bfhk1v33{background-color:var(--ds-background-accent-gray-subtler,#dcdfe4)}\n._bfhkr4aa{background-color:var(--ds-icon-subtle,#8993a4)}\n._i0dl1osq{flex-basis:100%}\n._w8l516xz svg{width:6pc}\n._w8l51qr7 svg{width:8pc}\n._w8l51tcg svg{width:24px}\n._w8l51ylp svg{width:40px}\n._w8l57vkz svg{width:1pc}\n._w8l5zwfg svg{width:2pc}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
